import React, { useState } from 'react';
import { App, Screenshot } from '../../../models/app';
import { Card, CardActionArea, Dialog, Fab, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { VideoPreview } from '../../VideoPreview';
import { CarouselWrapper, carouselWrapperConfig } from '../../Common/Carousels/CarouselWrapper';
import { CarouselTypes } from '../../Common/Carousels/config';
import { Close } from '@material-ui/icons';
import { sanitizeText } from '../../../utils/helpers';
import { getLocalizedAppDetails } from '../../../component-helpers/app-details';
import LimitedLinesTextBlock from '../../Common/LimitedLinesTextBlock';
import { detectScreenShotLocale } from '../../../utils/transformationHelper';

interface ComponentProps {
  app: App;
}

export const AppDetailedDescription: React.FC<ComponentProps> = ({ app }): JSX.Element => {
  const { t } = useTranslation();
  const [screenshot, setShowImg] = useState<Screenshot>();
  const { videoUrl, description } = getLocalizedAppDetails(app);

  const screenshots = detectScreenShotLocale(app);

  let carouselWrapperConfigToBuild: carouselWrapperConfig = {
    noHeader: true,
    carouselKey: CarouselTypes.Dialog,
    initialSlide: screenshots.indexOf(screenshot!),
  };

  const sanitisedDescription = sanitizeText(description!);

  const showDescriptionSection = !!description || !!videoUrl || screenshots.length > 0;

  return (
    <>
      {showDescriptionSection && (
        <Paper square>
          <h3 data-testid="descriptionHeader">{t('app_details.description')}</h3>
          <CarouselWrapper
            carouselWrapperConfig={{ noHeader: true, carouselKey: CarouselTypes.Slider, noTopPadding: true }}
          >
            {!!videoUrl && <VideoPreview videoUrl={videoUrl} />}
            {screenshots.map(media => (
              <div key={media.name}>
                <Card elevation={0} className={styles.media}>
                  <CardActionArea disableRipple onClick={() => setShowImg(media)}>
                    <img src={media.large} alt={media.name} data-testid="screenShots" />
                  </CardActionArea>
                </Card>
              </div>
            ))}
          </CarouselWrapper>

          <Dialog
            className={styles.dialog}
            open={!!screenshot}
            maxWidth="md"
            onClose={() => setShowImg(undefined)}
            aria-labelledby={screenshot?.name}
          >
            <Card elevation={0} style={{ maxWidth: '100%', maxHeight: '100%' }}>
              <CarouselWrapper carouselWrapperConfig={carouselWrapperConfigToBuild}>
                {screenshots.map(media => (
                  <div key={media.name} className={styles.mediaButton}>
                    <img src={media.large} alt={media.name} />
                  </div>
                ))}
              </CarouselWrapper>
            </Card>
            <Fab
              data-testid="closeButton"
              className={styles.fab}
              size="medium"
              onClick={() => setShowImg(undefined)}
            >
              <Close />
            </Fab>
          </Dialog>

          <LimitedLinesTextBlock
            numberOfLines={4}
            body={sanitisedDescription}
            useDangerouslySetInnerHTML={true}
            upperCasedButtons={true}
          />
        </Paper>
      )}
    </>
  );
};
